<template>
  <div class="d-flex flex-column min-vh-100">


    <!-- Main Content -->
    <main class="flex-fill py-4">
      <div class="container">
        <div class="row">

          <div class="col-md-12">
            <!-- Main Content Area -->
            <div class="p-3 bg-white border rounded">
              <div class="section__heading mb-50 text-center">
                <img src="/assets/img/logo-dark.png" alt="logo-img" style="width:300px;margin:0 auto" />
                <h3 class="section__heading--title mb-10"> منصة أكاديميا </h3>
                <h2 class="section__heading--desc alert alert-success"> <b> إصنع باقتك الخاصة بنفسك
                  </b>
                </h2>
              </div>
            </div>
          </div>
          <router-view />

        </div>
      </div>
    </main>

    <!-- Footer -->
    <footer class="bg-dark text-white py-3">
      <div class="container text-center">
        <p> جميع الحقوق محفوظة <a style="color:#00c444" href="https://student.academia.ly">منصة
            أكاديميا</a> &copy; <span id="currentYear"></span> </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "MainLayout",
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
